import React from 'react'
import { Box, Typography } from '@mui/material'

import Image from '../Image'
import { SectionDivider } from '../SectionDivider'

import { LinkAnimation } from './LinkAnimation'

type LeftContentRightImageProps = {
  data: {
    title: string
    content: { children: { text: string }[] }[]
    right_image: { asset: { url: string } }
    addlink: { cmnlink: string; cmnlinktext: string }
  }
}

export const LeftContentRightImage = ({ data }: LeftContentRightImageProps) => (
  <Box
    sx={{
      pt: { xs: 5.5, mobile: 11, laptop: 12 }
    }}>
    <Box
      sx={{
        display: { laptop: 'flex' },
        maxWidth: 1152,
        mx: 'auto',
        pb: { xs: 8, mobile: 10, laptop: 12 },
        px: {
          xs: 3,
          mobile: 8,
          laptop: 4,
          desktop: 0
        }
      }}>
      <Box sx={{ maxWidth: 550, mr: 5 }}>
        <Typography
          variant='h1'
          component='h2'
          sx={{ fontSize: { laptop: 54 } }}>
          {data.title}
        </Typography>

        <Typography sx={{ mb: 3, mt: 2 }}>
          {data.content[0].children[0].text}
        </Typography>

        <LinkAnimation
          link={data.addlink.cmnlink}
          text={data.addlink.cmnlinktext}
        />
      </Box>

      <Box sx={{ mt: { xs: 5, laptop: 0 } }}>
        <Image url={data.right_image.asset?.url} />
      </Box>
    </Box>

    <SectionDivider />
  </Box>
)
